import { FeApi } from '@/api/fe-api';
import type { DataResult } from '@/warranty-v3/entities/data-result';

import { conditionViolationsMapper } from './condition-violation-mapper';
import { unitOverviewMapper } from './unit-overview-mapper';
import { warrantyPenaltiesMapper } from './warranty-penalty-mapper';

export function dataResultMapper(
  data: FeApi.WarrantyDataViewOutput,
): DataResult {
  return {
    unitOverview: unitOverviewMapper(data.unit_overview),
    warrantyPenalties: warrantyPenaltiesMapper(data.warranty_penalties),
    conditionViolations: conditionViolationsMapper(data.condition_violations),
  };
}
